import { CircularProgress, TableCell, TableRow, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function CopDocumentPendingRow({ name, type }) {
    const isUrl = type === "url"
    return (
        <TableRow sx={{ opacity: 0.6 }}>
            <TableCell>
                <Iconify
                    icon={isUrl ? "mdi:link-variant" : "mdi:file-pdf-box"}
                    sx={{ color: isUrl ? "info.main" : "error.main" }}
                />
            </TableCell>
            <TableCell>
                <Typography variant="body2">{name}</Typography>
            </TableCell>
            <TableCell />
            <TableCell />
            <TableCell align="center">
                <CircularProgress size={16} />
            </TableCell>
            <TableCell />
            <TableCell />
        </TableRow>
    )
}
